module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('router-link', {
    staticClass: "rout-bot bot-left hvr-grow",
    attrs: {
      "aria-label": "Página anterior",
      "to": "/"
    }
  }), _vm._v(" "), _c('ui-title-red', {
    attrs: {
      "textTitle": "Introducción"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "text-xs-center": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Introducción',
      "videoEmbed": "info01comoadministrar.mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), (_vm.videoAcc) ? _c('v-flex', {
    staticClass: "animated fadeIn dura_1",
    attrs: {
      "xs12": "",
      "sm12": "",
      "text-xs-center": ""
    }
  }, [_c('br'), _vm._v(" "), _c('video-app', {
    staticClass: "adorn-bottom",
    attrs: {
      "videoSize": 700,
      "vidTittle": "video Presentacion",
      "youtubeEmbed": "3jn8-qHEI5w?autoplay=1&rel=0"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53beb01c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-01.vue
// module id = 971
// module chunks = 1